export interface TooltipWrapperProps {
  tooltipText?: string
  children: any
  position?: string
  showTooltipOnClick?: boolean | undefined
  dataBdd?: string | undefined
  tooltipStyles?: string
  accountForScrollbar?: boolean
  hidePointer?: boolean
  tooltipChildStyles?: string
}

export enum TooltipPosition {
  TOP = 'top',
  BOTTOM = 'bottom',
  LEFT = 'left',
  RIGHT = 'right'
}